
import { defineComponent, ref, watch, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { TerminalIconRound } from '@/views/dashboard/_enum/terminal-icon-round'
import OperateSystem from '@/views/dashboard/group/client/terminal-info/operate-system/operate-system.vue'
import ExaminationInfo from '@/views/dashboard/group/client/terminal-info/examination-info/examination-info.vue'
import TerminalHead from '@/views/dashboard/group/client/terminal-info/terminal-head/terminal-head.vue'
import HardwareInfo from '@/views/dashboard/group/client/terminal-info/hardware-info/hardware-info.vue'
import NetworkConfig from '@/views/dashboard/group/client/terminal-info/network-config/network-config.vue'
import BaseInfo from '@/views/dashboard/group/client/terminal-info/base-info/base-info.vue'
import ChangeLog from '@/views/dashboard/group/client/terminal-info/change-log/change-log.vue'
import IssueStrategy from '@/views/dashboard/group/client/terminal-info/issue-strategy/issue-strategy.vue'
import VulnerabilityInfo from '@/views/dashboard/group/client/terminal-info/vulnerability-info/vulnerability-info.vue'
import SoftwareInfo from '@/views/dashboard/group/client/terminal-info/software-info/software-info.vue'
import { BaseInfoRes, TerminalInfoService } from '@/views/dashboard/group/client/terminal-info/terminal-info.service'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { AccountStatus } from '@/views/dashboard/group/client/terminal-info/base-info/base-info.service'
import { PropType } from 'vue/dist/vue'
import { ClientItem } from '@/views/dashboard/_type/client-item'

export default defineComponent({
  components: {
    TerminalHead,
    BaseInfo,
    OperateSystem,
    NetworkConfig,
    SoftwareInfo,
    HardwareInfo,
    ChangeLog,
    ExaminationInfo,
    VulnerabilityInfo,
    IssueStrategy,
  },

  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    terminalInfo: {
      type: Object as PropType<ClientItem>,
      default: () => ({})
    },
  },

  setup (props, context) {
    const { t, locale } = useI18n()
    const injector = useReflectiveInjector([TerminalInfoService])
    const service = injector.get(TerminalInfoService)
    const isLoading = ref(false)
    const activeTab = ref('basicInfo')
    const baseInfo = ref({} as BaseInfoRes)
    const drawerTitle = computed(() => {
      void locale.value
      return t('groupClient.terminalInfoDrawerTitle', {
        name: baseInfo.value?.computer_name ?? '',
      })
    })
    let statusInterval = null

    function updateData () {
      isLoading.value = true
      service.getBaseInfo({
        device_id: props.terminalInfo.device_id
      }).then(res => {
        baseInfo.value = res
        startLoopStatus()
      }).finally(() => {
        isLoading.value = false
      })
    }

    function startLoopStatus () {
      clearInterval(statusInterval)
      statusInterval = setInterval(() => {
        const hasProcessing = baseInfo.value.accounts.find(v => v.status === AccountStatus.enabling || v.status === AccountStatus.disabling)
        if (hasProcessing) {
          service.getBaseInfo({ device_id: props.terminalInfo.device_id }).then(res => {
            baseInfo.value = res
          })
        } else {
          clearInterval(statusInterval)
        }
      }, 500)
    }

    function handleClose () {
      context.emit('update:modelValue', false)
    }

    function handleRefresh () {
      context.emit('refresh')
    }

    watch(() => props.modelValue, (value) => {
      if (value) {
        updateData()
        activeTab.value = 'basicInfo'
      }
    })

    return {
      TerminalIconRound,
      isLoading,
      activeTab,
      baseInfo,
      drawerTitle,
      handleRefresh,
      updateData,
      handleClose,
    }
  }
})
